module.exports = __webpack_public_path__ + "static/media/12650565_1058937487461006_1563862316_n_edited.2a4ba379.jpg";